export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
              投稿爆料
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              有猛料？欢迎通过以下方式联系我们，期待你的独家线索
            </p>
          </div>

          <div className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              <div className="text-center p-4 rounded-xl bg-background-100 border border-background-200/40">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-500/10 text-primary-500">
                  <i className="ri-mail-send-line text-xl"></i>
                </div>
                <h3 className="mt-3 text-sm font-semibold text-foreground-800">邮件投稿</h3>
                <p className="mt-1 text-xs text-foreground-500">tips@heiliao.online</p>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-100 border border-background-200/40">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-500/10 text-accent-500">
                  <i className="ri-wechat-line text-xl"></i>
                </div>
                <h3 className="mt-3 text-sm font-semibold text-foreground-800">微信联系</h3>
                <p className="mt-1 text-xs text-foreground-500">搜索：黑料在线客服</p>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-100 border border-background-200/40">
                <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-500/10 text-secondary-500">
                  <i className="ri-chat-smile-2-line text-xl"></i>
                </div>
                <h3 className="mt-3 text-sm font-semibold text-foreground-800">在线留言</h3>
                <p className="mt-1 text-xs text-foreground-500">24小时内回复</p>
              </div>
            </div>

            <form className="space-y-4" onSubmit={(e) => { e.preventDefault(); }}>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <input
                    type="text"
                    name="name"
                    placeholder="你的昵称"
                    className="w-full px-4 py-3 rounded-xl bg-background-100 border border-background-200/60 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500/40 transition-colors"
                  />
                </div>
                <div>
                  <input
                    type="email"
                    name="email"
                    placeholder="联系邮箱"
                    className="w-full px-4 py-3 rounded-xl bg-background-100 border border-background-200/60 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500/40 transition-colors"
                  />
                </div>
              </div>
              <div>
                <select
                  name="category"
                  className="w-full px-4 py-3 rounded-xl bg-background-100 border border-background-200/60 text-sm text-foreground-800 focus:outline-none focus:border-primary-500/40 transition-colors"
                  defaultValue=""
                >
                  <option value="" disabled>选择投稿类型</option>
                  <option value="breaking">爆料线索</option>
                  <option value="series">系列投稿</option>
                  <option value="correction">内容纠正</option>
                  <option value="cooperation">商务合作</option>
                  <option value="other">其他</option>
                </select>
              </div>
              <div>
                <textarea
                  name="message"
                  rows={4}
                  maxLength={500}
                  placeholder="请详细描述你的爆料内容（最多500字）..."
                  className="w-full px-4 py-3 rounded-xl bg-background-100 border border-background-200/60 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500/40 transition-colors resize-none"
                ></textarea>
              </div>
              <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="anti-spam-field" />
              <div className="text-center">
                <button
                  type="submit"
                  className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-send-plane-fill"></i>
                  提交爆料
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}